var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 5.333c-.265.001-.52-.105-.707-.293L10.96 1.707c-.367-.394-.356-1.008.025-1.39.38-.38.994-.39 1.388-.024l3.334 3.334c.285.286.37.715.216 1.089-.155.373-.519.617-.923.617zM6.667 2.667C2.985 2.667 0 5.65 0 9.333 0 13.015 2.985 16 6.667 16s6.666-2.985 6.666-6.667c-.004-3.68-2.986-6.662-6.666-6.666zM10 10H6.667C6.298 10 6 9.702 6 9.333V6c0-.368.298-.667.667-.667.368 0 .666.299.666.667v2.667H10c.368 0 .667.298.667.666 0 .369-.299.667-.667.667z",
    transform: "translate(0 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.c3f222df480c6ef5af6151056018e58e.svg";
export { ForwardRef as ReactComponent };